import { render, staticRenderFns } from "./PXSurveyOverviewPage.vue?vue&type=template&id=2cf75f4f&scoped=true"
import script from "./PXSurveyOverviewPage.vue?vue&type=script&lang=js"
export * from "./PXSurveyOverviewPage.vue?vue&type=script&lang=js"
import style0 from "./PXSurveyOverviewPage.vue?vue&type=style&index=0&id=2cf75f4f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf75f4f",
  null
  
)

export default component.exports